import { valueForKeyPath } from 'key.path'
// ///////////////////////////////////////////////////////
import { value, merge } from './utils'

// ///////////////////////////////////////////////////////
const EDGES = /^[mp][trblhv]?$/
//               ||  ||||||
//         margin |  ||||| vertical
//           padding |||| horizontal
//                   ||||
//                top || left
//                    | bottom
//                  right

const defaultSpacing = [0, 8, 16, 32, 64]

// ///////////////////////////////////////////////////////
export const composeBoxModelSpacing = props => {
  // Check filter the props based on the EDGES
  const keys = Object.keys(props).filter(k => EDGES.test(k)).sort()
  // Convert the prop name and/or value in a more standardized way.
  // py => paddingTop/paddingBottom
  const spacing = valueForKeyPath('theme.spacing', props) || defaultSpacing
  // ////////////////////////////
  return keys.map(key => {
    return getProperties(key).reduce((a, b) => Object.assign(a, {
      [b]: value(spacing)(props[key])
    }), {})
  }).reduce(merge, {})
}
// ///////////////////////////////////////////////////////
const getProperties = key => {
  const [ a, b ] = key.split('')
  const prop = properties[a]
  const dirs = directions[b] || [ '' ]
  return dirs.map(dir => prop + dir)
}
const properties = {
  m: 'margin',
  p: 'padding'
}
const directions = {
  t: [ 'Top' ],
  r: [ 'Right' ],
  b: [ 'Bottom' ],
  l: [ 'Left' ],
  h: [ 'Left', 'Right' ],
  v: [ 'Top', 'Bottom' ]
}
